import Alert from 'components/atoms/Alert/Alert';
import { useSurveyDemographicInformationFragment } from './useSurveyDemographicInformationFragment';
import classes from './SurveyDemographicsInformation.module.scss';
import MoreSurveysBanner from 'components/molecules/MoreSurveysBanner/MoreSurveysBanner';
import type { useSurveyDemographicInformationFragment_demographicProfileUrl$key } from './__generated__/useSurveyDemographicInformationFragment_demographicProfileUrl.graphql';

export type Props = {
  demographicProfileUrlRef: useSurveyDemographicInformationFragment_demographicProfileUrl$key;
};

export default function SurveyDemographicInformation({ demographicProfileUrlRef }: Props) {
  const data = useSurveyDemographicInformationFragment(demographicProfileUrlRef);

  return data.demographicProfileUrl ? (
    <iframe src={data.demographicProfileUrl} className={classes.iframe} />
  ) : (
    <>
      <Alert
        title={''}
        type={'info'}
        onClose={undefined}
        subtitle={"It looks like you haven't been matched to surveys yet."}
      />
      <div className={classes.bannerContainer}>
        <MoreSurveysBanner profileUrlRef={data} className={classes.moreSurveysBanner} />
      </div>
    </>
  );
}
